import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './baseQuery';

export interface IPointUsedLogResponse {
  point_used_logs_id: number;
  point_used_logs_user_id: number;
  point_used_logs_present_id: number;
  presents_title: string;
  point_used_logs_point_used: number;
  point_used_logs_point_used_at: string;
  point_used_logs_history_id: string | null;
  user_name: string;
  user_mail: string;
  kyash_account: string | null;
  bank_account_holder_name: string | null;
  transfer_type: 'kyash' | 'bank' | 'dmoney' | string;
  giftee_failed_logs_error_text: string | null;
}

export interface IPointUsedLogListResponse {
  data: IPointUsedLogResponse[];
  total: number;
  currentPage?: number;
  limitPerPage?: number;
}

export const pointUsedLogApi = createApi({
  reducerPath: 'pointUsedLog_api',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['pointUsedLog'],
  endpoints: build => ({
    getPointUsedLogs: build.query<IPointUsedLogListResponse, string>({
      query: params => ({
        url: `/point_used_logs${params && '?' + params}`,
        method: 'GET',
      }),
      transformResponse: (response: {
        data_response: IPointUsedLogResponse[];
        total_count: number;
        current_page?: number;
        limit_per_page?: number;
      }) => ({
        data: response.data_response,
        total: response.total_count,
        currentPage: response.current_page,
        limitPerPage: response.limit_per_page,
      }),
      providesTags: ['pointUsedLog'],
    }),
  }),
});

export const { useGetPointUsedLogsQuery } = pointUsedLogApi;
